var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBandintown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9629 2.01782H17.126V12.2741H20.9629V2.01782Z",
    fill: "#00CEC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8349 7.40381H11.998V12.2742H15.8349V7.40381Z",
    fill: "#00CEC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9673 7.40381H7.13037V12.2742H10.9673V7.40381Z",
    fill: "#00CEC8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25977 2.01782V22.0122H16.8315H17.1261H20.9998V13.6389H7.24062V17.2891H17.1261V18.3594H6.13347V2.01782H2.25977Z",
    fill: "#00CEC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandintown);
export default __webpack_public_path__ + "static/media/bandintown.7f167741.svg";
export { ForwardRef as ReactComponent };